const quantityInputs = document.querySelectorAll('.pi-qty .quantity-selector__value');
const plusButtons = document.querySelectorAll('.pi-qty .plus');
const minusButtons = document.querySelectorAll('.pi-qty .minus');

plusButtons.forEach((plusButton, index) => {
    plusButton.addEventListener('click', function() {
        let currentQuantity = parseInt(quantityInputs[index].value);
        currentQuantity++;
        quantityInputs[index].value = currentQuantity;
    });
});

minusButtons.forEach((minusButton, index) => {
    minusButton.addEventListener('click', function() {
        let currentQuantity = parseInt(quantityInputs[index].value);
        if (currentQuantity > 1) {
            currentQuantity--;
            quantityInputs[index].value = currentQuantity;
        }
    });
});

// \snippets\option-tabs.liquid
$(document).on('click', '.card__collapsible-heading-text', function() {
  var $this = $(this);

  if ($this.hasClass('button--primary')) return;

  let dataText = $this.data('text');

  $('.card__collapsible-heading-text.button--primary')
    .removeClass('button--primary')
    .addClass('button--secondary');

  $this
    .removeClass('button--secondary')
    .addClass('button--primary');

    $this.parents('.card__collapsible-content').find('.card__collapsible--content').hide();
    $this.parents('.card__collapsible-content').find('.card__collapsible--content-'+dataText).show();
    
});